/**
 * OTURUM KUŞAĞI (geç yanıt turu, 22.10.2026).
 *
 * Depo her oturum sınırında (çıkış, giriş, hesap geçişi, diriltme) bir sayacı
 * ARTIRIR. `createApiSaga` isteği başlatırken sayacı okur ve yanıtı yazmadan
 * önce yeniden okur: arada sınır geçildiyse yanıt önceki oturumundur ve HİÇBİR
 * dilime yazılmaz (başarı, hata ve onların `onSuccess`/`onFailure` kancaları).
 * Yazılan başarı ve hata eylemleri kuşağı `meta.sessionEpoch` olarak taşır;
 * kök reducer kuşağı uymayan damgalı eylemi aynı kuralla (`isSupersededAction`)
 * yutar. Kural tek fonksiyondadır, saga ve reducer onu çağırır.
 *
 * Neden sayaç, neden kullanıcı kimliği değil: girişten önce kimlik yoktur ve
 * aynı hesaba çıkıp yeniden girmek de bir sınırdır. Kimlik iki oturumu aynı
 * sayardı; sayaç saymaz.
 */
export const SESSION_EPOCH_META = 'sessionEpoch';
/** Eylemin taşıdığı kuşak; damgasız eylemde `null`. */
export function sessionEpochOf(action) {
    const meta = action.meta;
    if (typeof meta !== 'object' || meta === null)
        return null;
    const epoch = meta[SESSION_EPOCH_META];
    return typeof epoch === 'number' ? epoch : null;
}
/** Damgalı eylem başka bir oturumdan mı geliyor? Damgasız eylem asla eskimiş sayılmaz. */
export function isSupersededAction(action, currentEpoch) {
    const epoch = sessionEpochOf(action);
    return epoch !== null && epoch !== currentEpoch;
}
/** Eylemi kuşakla damgalar; mevcut `meta` alanları korunur. */
export function stampSessionEpoch(action, epoch) {
    const meta = action.meta;
    const base = typeof meta === 'object' && meta !== null ? meta : {};
    return { ...action, meta: { ...base, [SESSION_EPOCH_META]: epoch } };
}
//# sourceMappingURL=session-epoch.js.map